export default __webpack_public_path__ + "static/media/hobby_video_post_1.bf368e2c.jpg";